// saveState.js
import store from "../store/store";
import { getCircularReplacer } from "../store/store";

/**
 * Saves the Redux state to sessionStorage, encoding it safely for transport.
 * @param {object} state - The Redux state to save. If not provided, will use store.getState() if store is passed.
 * @param {function} [getCircularReplacer] - Optional replacer to handle circular references.
 * @param {object} [store] - Optional Redux store to get state from if state is not provided.
 */
export function saveStateForNewTab() {
  try {
    const state = store.getState();
    const replacer = typeof getCircularReplacer === "function" ? getCircularReplacer() : undefined;
    const serializedState = JSON.stringify(state, replacer);
    // Encode serialized state using btoa
    const encodedState = btoa(unescape(encodeURIComponent(serializedState)));
    sessionStorage.setItem("state", encodedState);
    // Remove state after 10 seconds
    setTimeout(() => {
      sessionStorage.removeItem("state");
    }, 10000);
  } catch (e) {}
}
